import { render } from "./ViewCatalog.vue?vue&type=template&id=9624ca84&scoped=true&ts=true"
import script from "./ViewCatalog.vue?vue&type=script&lang=ts"
export * from "./ViewCatalog.vue?vue&type=script&lang=ts"

import "./ViewCatalog.vue?vue&type=style&index=0&id=9624ca84&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9624ca84"]])

export default __exports__